
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {StoreClientLoginSuccess2Response} from './StoreClientLoginSuccess2Response';
import {ClientLoginInfoRecord} from '../core/ClientLoginInfoRecord';
import {FieldModelClientLoginInfoRecord} from '../core/ClientLoginInfoRecord';

/**
 * StoreClientLoginSuccess2Request struct
 */
class StoreClientLoginSuccess2Request extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!ClientLoginInfoRecord=} clientLoginInfo
   * @param {!number=} accountActualVersion
   * @constructor
   */
  constructor (parent = new Request(), clientLoginInfo = new ClientLoginInfoRecord(), accountActualVersion = new UInt64(0, 0)) {
    super()
    super.copy(parent)
    this.ClientLoginInfo = clientLoginInfo
    this.AccountActualVersion = accountActualVersion
  }

  /**
   * Copy struct (shallow copy)
   * @this {!StoreClientLoginSuccess2Request}
   * @param {!StoreClientLoginSuccess2Request} other Other struct
   * @returns {!StoreClientLoginSuccess2Request} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.ClientLoginInfo != null) {
      this.ClientLoginInfo = ClientLoginInfoRecord.fromObject(other.ClientLoginInfo)
    } else {
      this.ClientLoginInfo = null
    }
    if (other.AccountActualVersion != null) {
      this.AccountActualVersion = UInt64.fromNumber(other.AccountActualVersion)
    } else {
      this.AccountActualVersion = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!StoreClientLoginSuccess2Request}
   * @returns {!StoreClientLoginSuccess2Request} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new StoreClientLoginSuccess2RequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new StoreClientLoginSuccess2RequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!StoreClientLoginSuccess2Request}
   * @param {!StoreClientLoginSuccess2Request} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof StoreClientLoginSuccess2Request)) {
      throw new TypeError('Instance of StoreClientLoginSuccess2Request is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!StoreClientLoginSuccess2Request}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      ClientLoginInfo: ((this.ClientLoginInfo != null) ? this.ClientLoginInfo : null),
      AccountActualVersion: ((this.AccountActualVersion != null) ? this.AccountActualVersion.toNumber() : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return StoreClientLoginSuccess2Request.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!StoreClientLoginSuccess2Request} other Object value
   * @returns {!StoreClientLoginSuccess2Request} Created struct
   */
  static fromObject (other) {
    return new StoreClientLoginSuccess2Request().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!StoreClientLoginSuccess2Request}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return StoreClientLoginSuccess2Request.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!StoreClientLoginSuccess2Request}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4103
  }
}

export { StoreClientLoginSuccess2Request };

/**
 * Fast Binary Encoding StoreClientLoginSuccess2Request field model
 */
class FieldModelStoreClientLoginSuccess2Request extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.ClientLoginInfo = new FieldModelClientLoginInfoRecord(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.AccountActualVersion = new fbe.FieldModelUInt64(buffer, this.ClientLoginInfo.fbeOffset + this.ClientLoginInfo.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelStoreClientLoginSuccess2Request}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelStoreClientLoginSuccess2Request}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelStoreClientLoginSuccess2Request}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.ClientLoginInfo.fbeSize + this.AccountActualVersion.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelStoreClientLoginSuccess2Request}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.ClientLoginInfo.fbeExtra + this.AccountActualVersion.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelStoreClientLoginSuccess2Request}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelStoreClientLoginSuccess2Request.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelStoreClientLoginSuccess2Request}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4103
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelStoreClientLoginSuccess2Request}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelStoreClientLoginSuccess2Request}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.ClientLoginInfo.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ClientLoginInfo.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClientLoginInfo.fbeSize

    if ((fbeCurrentSize + this.AccountActualVersion.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountActualVersion.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountActualVersion.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelStoreClientLoginSuccess2Request}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelStoreClientLoginSuccess2Request}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelStoreClientLoginSuccess2Request}
   * @param {!StoreClientLoginSuccess2Request} fbeValue Default value, defaults is new StoreClientLoginSuccess2Request()
   * @returns {!StoreClientLoginSuccess2Request} StoreClientLoginSuccess2Request value
   */
  get (fbeValue = new StoreClientLoginSuccess2Request()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelStoreClientLoginSuccess2Request}
   * @param {!StoreClientLoginSuccess2Request} fbeValue StoreClientLoginSuccess2Request value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.ClientLoginInfo.fbeSize) <= fbeStructSize) {
      fbeValue.ClientLoginInfo = this.ClientLoginInfo.get()
    } else {
      fbeValue.ClientLoginInfo = new ClientLoginInfoRecord()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClientLoginInfo.fbeSize

    if ((fbeCurrentSize + this.AccountActualVersion.fbeSize) <= fbeStructSize) {
      fbeValue.AccountActualVersion = this.AccountActualVersion.get()
    } else {
      fbeValue.AccountActualVersion = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountActualVersion.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelStoreClientLoginSuccess2Request}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelStoreClientLoginSuccess2Request}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelStoreClientLoginSuccess2Request}
   * @param {!StoreClientLoginSuccess2Request} fbeValue StoreClientLoginSuccess2Request value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelStoreClientLoginSuccess2Request}
   * @param {StoreClientLoginSuccess2Request} fbeValue StoreClientLoginSuccess2Request value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.ClientLoginInfo.set(fbeValue.ClientLoginInfo)
    this.AccountActualVersion.set(fbeValue.AccountActualVersion)
  }
}

export { FieldModelStoreClientLoginSuccess2Request };

/**
 * Fast Binary Encoding StoreClientLoginSuccess2Request model
 */
class StoreClientLoginSuccess2RequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelStoreClientLoginSuccess2Request(this.buffer, 4)
  }

  /**
   * Get the StoreClientLoginSuccess2Request model
   * @this {!StoreClientLoginSuccess2RequestModel}
   * @returns {!FieldModelStoreClientLoginSuccess2Request} model StoreClientLoginSuccess2Request model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!StoreClientLoginSuccess2RequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!StoreClientLoginSuccess2RequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return StoreClientLoginSuccess2RequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!StoreClientLoginSuccess2RequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelStoreClientLoginSuccess2Request.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!StoreClientLoginSuccess2RequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!StoreClientLoginSuccess2RequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!StoreClientLoginSuccess2RequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!StoreClientLoginSuccess2RequestModel}
   * @param {!StoreClientLoginSuccess2Request} value StoreClientLoginSuccess2Request value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!StoreClientLoginSuccess2RequestModel}
   * @param {!StoreClientLoginSuccess2Request} value StoreClientLoginSuccess2Request value, defaults is new StoreClientLoginSuccess2Request()
   * @return {!object} Deserialized StoreClientLoginSuccess2Request value and its size
   */
  deserialize (value = new StoreClientLoginSuccess2Request()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new StoreClientLoginSuccess2Request(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new StoreClientLoginSuccess2Request(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!StoreClientLoginSuccess2RequestModel}
   * @param {!number} prev Previous StoreClientLoginSuccess2Request model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { StoreClientLoginSuccess2RequestModel };
StoreClientLoginSuccess2Request.__has_response = true;
StoreClientLoginSuccess2Request.__response_class = StoreClientLoginSuccess2Response;
